<!-- 我的页面 -->
<template>
  <a-layout-sider :width="siderFlag ? 236 : 80" class="layout-sider" :style="{ paddingRight: siderFlag ? '24px' : '0'}">
    <div class="sider-expended" :style="siderFlag?'':'padding: 0'">
      <template v-if="siderFlag">
        <div class="logo" key="logo">
          <img src="@/assets/images/logo.svg" width="160" alt/>
        </div>
      </template>
      <template v-else>
        <div class="logo" key="icon">
          <img src="@/assets/images/menu/cyber-icon.png" width="40" style="margin-left: 20px" alt/>
        </div>
      </template>
    </div>
    <!-- <a-button class="suggest-btn" type="primary" ghost @click="turnTo('https://cyberklick.gitbook.io/cybermedia-cao-zuo-zhi-nan/~/changes/2Vxc0mHmi9LVvqkOvUJw/qi-ta-fu-wu/cyberdata-tou-fang-xiao-guo-fen-xi-ping-tai/jian-yi-fan-kui')">🎉 建议反馈</a-button> -->
    <a-menu
      :key="menuListKey"
      ref="menu"
      theme="light"
      :class="siderFlag ? 'cont-menu' : 'sub-cont-menu'"
      mode="inline"
      :openKeys.sync="openKeys"
      v-model="selectedKeys"
      :inlineIndent="22"
      @click="changNav"
    >
      <template v-for="v in menuAllList">        
        <a-menu-item-group :key="v.routeName" :title="v.name" v-if="siderFlag"></a-menu-item-group>
        <template v-for="val in v.resources">
          <template v-if="val.resources&&val.resources.length">
            <a-sub-menu
              :key="val.routeName"
            >
              <span slot="title">
                <template v-if="menuImg[val.routeName]">
                  <img class="menu-image normal" :src="menuImg[val.routeName].normal" alt="">
                  <img class="menu-image hover" :src="menuImg[val.routeName].hover" alt="">
                </template>
                <icon-font v-else :type="val.icon"/>
                <span>{{val.name}}</span>
              </span>
              <a-menu-item :key="value.routeName" v-for="value in val.resources || []">
                <span>{{value.name}}</span>
              </a-menu-item>
            </a-sub-menu>
          </template>
          <template v-else>
            <a-menu-item :key="val.routeName">
              <div>
                <template v-if="menuImg[val.routeName]">
                  <img class="menu-image normal" :src="menuImg[val.routeName].normal" alt="">
                  <img class="menu-image hover" :src="menuImg[val.routeName].hover" alt="">
                </template>
                <icon-font v-else :type="val.icon"/>
                <span v-if="siderFlag">{{val.name}}</span>
              </div>
            </a-menu-item>
          </template>
        </template>       
      </template>
    </a-menu>
    <!-- <div class="expand-icon" :class="!siderFlag ? 'positions' : ''" @click="siderFlag=!siderFlag"  :style="siderFlag?'':'left: 16px'">
      <img :src="!siderFlag ? require('./../../assets/images/menu/icon-expand.png') : require('./../../assets/images/menu/icon-put-away.png')" alt="">
    </div> -->
  </a-layout-sider>
</template>

<script>
import { mapState } from "vuex";
// import SubMenu from "./SubMenu";
/* 获得数组子节点的父节点  先不删，怕提需求 */
const getFatherKey = (datas, name, type = "children") => {
  if (datas.length === 0) {
    return [];
  }
  let fatherKeys = "";
  let result = [];
  try {
    const getChild = (data, str = "") => {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        if (node.routeName === name) {
          fatherKeys = str;
          throw new Error("GOT IT!");
        } else {
          if (Array.isArray(node[type]) && node[type].length) {
            str = str + "," + node.routeName;
            getChild(node[type], str);
          }
        }
      }
    };
    getChild(datas);
  } catch (error) {
    result = fatherKeys.split(",").filter(item => item);
  }
  return result;
};
export default {
  name: "Sidebar",
  // components: { SubMenu },
  data() {
    // 这里存放数据
    return {
      siderFlag: true,
      menuList: {
        id: 10000,
        resources: []
      },
      openKeys: [],
      // key值变化会使侧边栏重新渲染，暂时的办法后面再改
      menuListKey: parseInt(new Date().getTime()) + "sidebar",
      selectedKeys: [],
      menuImg: {
        categoryAnalysis: {
          normal: require('./../../assets/images/menu/category-analysis.svg'),
          hover: require('./../../assets/images/menu/category-analysis1.svg'),
        },
        analysisTemplate: {
          normal: require('./../../assets/images/menu/analysis-template.svg'),
          hover: require('./../../assets/images/menu/analysis-template1.svg'),
        },
        chartSubscription: {
          normal: require('./../../assets/images/menu/chart-subscription1.svg'),
          hover: require('./../../assets/images/menu/chart-subscription.svg'),
        },
        smartWarning: {
          normal: require('./../../assets/images/menu/smart-warning.svg'),
          hover: require('./../../assets/images/menu/smart-warning1.svg'),
        },
        downloadCenter: {
          normal: require('./../../assets/images/menu/download-center.svg'),
          hover: require('./../../assets/images/menu/download-center1.svg'),
        },
        mediaData: {
          normal: require('./../../assets/images/menu/media-data.svg'),
          hover: require('./../../assets/images/menu/media-data1.svg'),
        },
        thirdpartyData: {
          normal: require('./../../assets/images/menu/thirdparty-data.svg'),
          hover: require('./../../assets/images/menu/thirdparty-data1.svg'),
        },
        mixData: {
          normal: require('./../../assets/images/menu/mix-data.svg'),
          hover: require('./../../assets/images/menu/mix-data1.svg'),
        },
        adminMgt: {
          normal: require('./../../assets/images/menu/admin-mgt.svg'),
          hover: require('./../../assets/images/menu/admin-mgt1.svg'),
        },
      }
    };
  },
  computed: {
    ...mapState({
      menuAllList: state => state.user.menuAllList,
      userInfo: state => state.user.userInfo
    }),
  },
  watch: {

  },
  mounted() {
    let path = this.$route.path
    let arr = path.split('/')
    this.selectedKeys = arr.slice(-1)
    this.openKeys = arr.slice(-2)
  },
  // 方法集合
  methods: {
    turnTo(url) {
      window.open(url, '__blank')
    },
    turnToBI() {
      if (window.location.host.includes("cyberklick")) {
        location.href = 'http://a662375f1fe5c448f9635eb42c703714-271241680.ap-southeast-1.elb.amazonaws.com/#/panel/index'
      } else {
        location.href = 'http://dataease-web.cyberdata-test.svc.cluster.local/#/panel/index'
      }
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    changNav(item) {
      console.log(item)
      if(item.key === 'goDashboard') {
        this.$nextTick(() => {
          let path = this.$route.path
          let arr = path.split('/')
          this.selectedKeys = arr.slice(-1)
          this.openKeys = arr.slice(-2)
        })
        window.open(`${location.origin}/goDashboard`, '_blank')
      } else {
        this.$router.push({ name: item.key }).catch(err => err);
      }
    },
    updateMenuSelected() {
      const name = this.$route.name;
      let isCurrent = false;
      for (let index = 0; index < this.menuAllList.length; index++) {
        const item = this.menuAllList[index];
        isCurrent = item.flatChildren.some(sin => sin.routeName === name);
        // 当前路由能匹配到菜单
        if (isCurrent) {
          this.$store.commit("user/SET_MENU", {
            index: index,
            name: name
          });
          break;
        }
      }
      // 当前路由匹配不到菜单时，显示其父级菜单
      if (!isCurrent) {
        const parentIndex = this.$route.matched.length - 2;
        const parentName = this.$route.matched[parentIndex].name;
        for (let index = 0; index < this.menuAllList.length; index++) {
          const item = this.menuAllList[index];
          const isParentCurrent = item.flatChildren.some(
            sin => sin.routeName === parentName
          );
          if (isParentCurrent) {
            this.$store.commit("user/SET_MENU", {
              index: index,
              name: parentName
            });
            break;
          }
        }
      }
    }
  },
};
</script>
<style lang="less">
@import "../../assets/styles/variables.less";
.layout-sider {
  background: #F3F6FD;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  transition: width .5s;
  .suggest-btn {
    position: absolute;
    bottom: 0;
    width: 70%;
    left: 15%;
  }
  .ant-menu-inline{
    border-right-color: transparent;
  }
  .ant-menu{
    background: transparent;
  }
  .ant-menu-item-group-list{
    .menu-item{
      margin-top: 8px;
      margin-bottom: 0 !important;
    }
    .menu-item:nth-of-type(1) {
      margin-top: 8px;
    }
  }
  .menu-item{
    padding-left: 14px !important;
  }
  .ant-menu-item.ant-menu-item-selected, .ant-menu-item.ant-menu-item-active,
  .ant-menu-submenu.ant-menu-submenu-active  {
    .normal{
      display: none !important;
    }
    .hover{
      display: inline-block !important;
    }
  }
  .menu-image{
    width: 24px;
    height: 24px;
    object-fit: contain;
    vertical-align: middle;
    display: inline-block;
    margin: -3px 12px 0;
  }
  .normal{
    display: inline-block;
  }
  .hover{
    display: none;
  }
  .sub-menu-group{
    position: relative;
    .ant-menu-item-group-title{
      position: relative;
      &:before{
        content: '';
        position: absolute;
        left: 50%;
        top: 4px;
        transform: translateX(-50%);
        width: 48px;
        height: 1px;
        background: #E0E7F7;
      }
    }
  }
  .cont-menu {
    border: none !important;
    // height: calc(100% - 90px);
    // overflow-x: hidden;
    // overflow-y: scroll;
    // & > * {
    //   width: 100%;
    // }
  }
  .sub-cont-menu{
    .ant-menu-item-selected{
      background: transparent !important;
      .menu-item-cont{
        width: 48px;
        height: 40px;
        background: #FAFDFB;
        border-radius: 6px 6px 6px 6px;
      }
    }
  }
  .sider-expended {
    padding-left: 28px;
    padding-right: 16px;
    .logo {
      padding: 4px 0 8px;
      padding-bottom: 16px;
      cursor: pointer;
      img{
        object-fit: contain;
      }
    }
    .current-media-info{
      width: 172px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 6px;
      margin: 5px 0 16px;
      opacity: 1;
      border: 1px solid #CBD5EE;
      cursor: pointer;
      line-height: 30px;
      .media-logo{
        width: 18px;
        height: 18px;
        object-fit: contain;
        border-radius: 3px;
        text-align: center;
        vertical-align: middle;
        margin-top: -1px;
        margin-left: 10px;
      }
      .current-media-text{
        line-height: 32px;
        font-size: 14px;
        font-weight: 400;
        margin-left: 4px;
        color: #2D3446;
      }
    }
    .ad-icon {
      color: @Dark-6;
      font-size: 24px;
      text-align: center;
    }
    .title {
      font-size: 12px;
      font-weight: 500;
      color: #6D7FAB;
      line-height: 40px;
    }
    .account-list {
      overflow-y: auto;
      height: 780px;
      cursor: pointer;
      .list-item {
        padding:10px;
        padding-left: 44px;
        border-radius: 6px;
        height: 56px;
        position: relative;
        cursor: pointer;
        &.active {
          background: @cyberklick-1;
          .account-name {
            color: @cyberklick-5;
          }
          .head-icon {
            color: @cyberklick-4;
          }
        }
        .head-icon {
          position: absolute;
          left: 12px;
          top: 12px;
          color: @Dark-6;
          font-size: 20px;
        }
        .account-name {
          line-height: 22px;
          font-size: 14px;
          font-weight: 500;
          color: @Dark-7;
          white-space:nowrap;
        }
        .account-id {
          line-height: 20px;
          font-size: 12px;
          color: @Dark-6;
          white-space:nowrap;
        }
      }
    }
  }
  .expand-icon{
    position: fixed;
    width: 24px;
    height: 24px;
    bottom: 30px;
    left: 200px;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .positions{
    //bottom: 265px;
    top: 640px;
    left: 25px !important;
  }
}
.drop-media-item{
  .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title{
    padding: 0;
  }
  .media-logo{
    width: 18px;
    height: 18px;
    object-fit: contain;
    border-radius: 3px;
    text-align: center;
    vertical-align: middle;
    margin-top: 7px;
    margin-left: 10px;
    line-height: 32px;
  }
  .current-media-text{
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    color: #2D3446;
  }
}
.media-sub-logo{
  width: 48px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #CBD5EE;
  margin: 0 auto;
  cursor: pointer;
  img{
    width: 18px;
    height: 18px;
    object-fit: contain;
    border-radius: 3px;
    vertical-align: middle;
    margin-top: 6px;
    margin-left: 13px;
  }
}
.ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected, .ant-dropdown-menu-item-selected > a, .ant-dropdown-menu-submenu-title-selected > a{
  background: #F2FAF3;
  .current-media-text{
    color: #22AC35 !important;
  }
}
</style>
<style>

  .logo {
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #2D3446;
    cursor: pointer;
  }
</style>
